<template>
  <router-view v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
  
  <!-- 全局登录弹窗 -->
  <LoginDialog
    :model-value="loginDialog.visible.value"
    @update:model-value="val => loginDialog.visible.value = val"
    :mode="loginDialog.mode.value"
    @success="loginDialog.onLoginSuccess"
  />
</template>

<script setup lang="ts">
import { provideLoginDialog, setGlobalLoginDialog } from '@/utils/useLoginDialog'
import LoginDialog from '@/components/LoginDialog/LoginDialog.vue'

// 提供全局登录弹窗
const loginDialog = provideLoginDialog()
setGlobalLoginDialog(loginDialog)
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
